// import React, { useState } from "react";
// import { Modal } from "antd";

// const CompanyFormModal = ({
//   showCompanyForm,
//   setShowCompanyForm,
//   selectedCompany,
//   setSelectedCompany,
//   handleCompanySubmit,
//   loading,
// }) => {
//   const [formData, setFormData] = useState({
//     company_name: "",
//     business_type: "",
//     business_description: "",
//     business_brief: "",
//     address: "",
//     caller_name: "",
//     phone: "",
//     email: "",
//     website: "",
//     established_year: "",
//     gst_number: "",
//     pan_number: "",
//     registration_number: "",
//   });

//   const [showAlert, setShowAlert] = useState(true);

//   React.useEffect(() => {
//     if (selectedCompany) {
//       setFormData(selectedCompany);
//     } else {
//       setFormData({
//         company_name: "",
//         business_type: "",
//         business_description: "",
//         business_brief: "",
//         address: "",
//         caller_name: "",
//         phone: "",
//         email: "",
//         website: "",
//         established_year: "",
//         gst_number: "",
//         pan_number: "",
//         registration_number: "",
//       });
//     }
//   }, [selectedCompany]);

//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     setFormData((prev) => ({
//       ...prev,
//       [name]: value,
//     }));
//   };

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     handleCompanySubmit(formData);
//   };

//   const handleCancel = () => {
//     setShowCompanyForm(false);
//     setSelectedCompany(null);
//     setFormData({
//       company_name: "",
//       business_type: "",
//       business_description: "",
//       business_brief: "",
//       address: "",
//       caller_name: "",
//       phone: "",
//       email: "",
//       website: "",
//       established_year: "",
//       gst_number: "",
//       pan_number: "",
//       registration_number: "",
//     });
//   };

//   return (
//     <Modal
//       title={selectedCompany ? "Edit Company" : "Add New Company"}
//       open={showCompanyForm}
//       onCancel={handleCancel}
//       footer={null}
//       width={900}
//       className="bootstrap-modal"
//       afterClose={() => {
//         setFormData({
//           company_name: "",
//           business_type: "",
//           business_description: "",
//           business_brief: "",
//           address: "",
//           caller_name: "",
//           phone: "",
//           email: "",
//           website: "",
//           established_year: "",
//           gst_number: "",
//           pan_number: "",
//           registration_number: "",
//         });
//       }}
//     >
//       <div className="col-12">
//         <div className="card" style={{ border: "none", boxShadow: "none" }}>
//           <form onSubmit={handleSubmit}>
//             <div className="card-body" style={{ padding: "0" }}>
//               <h4 className="card-title">
//                 {selectedCompany ? "Edit Company" : "Company Registration"}
//               </h4>
//             </div>

//             <div className="card-body">
//               <div className="row">
//                 <div className="col-md-6">
//                   <div className="mb-3">
//                     <label htmlFor="company_name" className="form-label">
//                       Company Name
//                     </label>
//                     <input
//                       type="text"
//                       className="form-control"
//                       id="company_name"
//                       name="company_name"
//                       value={formData.company_name}
//                       onChange={handleInputChange}
//                       placeholder="Enter Company Name"
//                       required
//                     />
//                   </div>
//                 </div>
//                 <div className="col-md-6">
//                   <div className="mb-3">
//                     <label htmlFor="business_type" className="form-label">
//                       Business Type
//                     </label>
//                     <select
//                       className="form-control"
//                       id="business_type"
//                       name="business_type"
//                       value={formData.business_type}
//                       onChange={handleInputChange}
//                     >
//                       <option value="">Select Business Type</option>
//                       <option value="Private Limited">Private Limited</option>
//                       <option value="Public Limited">Public Limited</option>
//                       <option value="Partnership">Partnership</option>
//                       <option value="Sole Proprietorship">
//                         Sole Proprietorship
//                       </option>
//                       <option value="LLP">LLP</option>
//                     </select>
//                   </div>
//                 </div>
//                 <div className="col-12">
//                   <div className="mb-3">
//                     <label
//                       htmlFor="business_description"
//                       className="form-label"
//                     >
//                       Business Description
//                     </label>
//                     <textarea
//                       className="form-control"
//                       id="business_description"
//                       name="business_description"
//                       value={formData.business_description}
//                       onChange={handleInputChange}
//                       rows="2"
//                       placeholder="Describe your business"
//                     />
//                   </div>
//                 </div>
//                 <div className="col-12">
//                   <div className="mb-3">
//                     <label htmlFor="business_brief" className="form-label">
//                       Business Brief
//                     </label>
//                     <textarea
//                       className="form-control"
//                       id="business_brief"
//                       name="business_brief"
//                       value={formData.business_brief}
//                       onChange={handleInputChange}
//                       rows="2"
//                       placeholder="Brief overview of your business"
//                     />
//                   </div>
//                 </div>
//                 <div className="col-12">
//                   <div className="mb-3">
//                     <label htmlFor="address" className="form-label">
//                       Address
//                     </label>
//                     <textarea
//                       className="form-control"
//                       id="address"
//                       name="address"
//                       value={formData.address}
//                       onChange={handleInputChange}
//                       rows="2"
//                       placeholder="Complete Address"
//                     />
//                   </div>
//                 </div>
//                 <div className="col-12">
//                   <div className="mb-3">
//                     <label htmlFor="caller_name" className="form-label">
//                       Contact Person
//                     </label>
//                     <input
//                       type="text"
//                       className="form-control"
//                       id="caller_name"
//                       name="caller_name"
//                       value={formData.caller_name}
//                       onChange={handleInputChange}
//                       placeholder="Primary Contact Person Name"
//                     />
//                   </div>
//                 </div>
//                 <div className="col-md-6">
//                   <div className="mb-3">
//                     <label htmlFor="phone" className="form-label">
//                       Phone Number
//                     </label>
//                     <input
//                       type="tel"
//                       className="form-control"
//                       id="phone"
//                       name="phone"
//                       value={formData.phone}
//                       onChange={handleInputChange}
//                       placeholder="Contact Number"
//                       required
//                     />
//                   </div>
//                 </div>
//                 <div className="col-md-6">
//                   <div className="mb-3">
//                     <label htmlFor="email" className="form-label">
//                       Email Address
//                     </label>
//                     <input
//                       type="email"
//                       className="form-control"
//                       id="email"
//                       name="email"
//                       value={formData.email}
//                       onChange={handleInputChange}
//                       placeholder="Email Address"
//                       required
//                     />
//                   </div>
//                 </div>
//                 <div className="col-md-6">
//                   <div className="mb-3">
//                     <label htmlFor="website" className="form-label">
//                       Website
//                     </label>
//                     <input
//                       type="url"
//                       className="form-control"
//                       id="website"
//                       name="website"
//                       value={formData.website}
//                       onChange={handleInputChange}
//                       placeholder="Company Website URL"
//                     />
//                   </div>
//                 </div>
//                 <div className="col-md-6">
//                   <div className="mb-3">
//                     <label htmlFor="established_year" className="form-label">
//                       Established Year
//                     </label>
//                     <input
//                       type="number"
//                       className="form-control"
//                       id="established_year"
//                       name="established_year"
//                       value={formData.established_year}
//                       onChange={handleInputChange}
//                       min="1900"
//                       max={new Date().getFullYear()}
//                       placeholder="Year Established"
//                     />
//                   </div>
//                 </div>
//                 <div className="col-md-4">
//                   <div className="mb-3">
//                     <label htmlFor="gst_number" className="form-label">
//                       GST Number
//                     </label>
//                     <input
//                       type="text"
//                       className="form-control"
//                       id="gst_number"
//                       name="gst_number"
//                       value={formData.gst_number}
//                       onChange={handleInputChange}
//                       placeholder="GST Registration Number"
//                     />
//                   </div>
//                 </div>
//                 <div className="col-md-4">
//                   <div className="mb-3">
//                     <label htmlFor="pan_number" className="form-label">
//                       PAN Number
//                     </label>
//                     <input
//                       type="text"
//                       className="form-control"
//                       id="pan_number"
//                       name="pan_number"
//                       value={formData.pan_number}
//                       onChange={handleInputChange}
//                       placeholder="PAN Number"
//                     />
//                   </div>
//                 </div>
//                 <div className="col-md-4">
//                   <div className="mb-3">
//                     <label htmlFor="registration_number" className="form-label">
//                       Registration Number
//                     </label>
//                     <input
//                       type="text"
//                       className="form-control"
//                       id="registration_number"
//                       name="registration_number"
//                       value={formData.registration_number}
//                       onChange={handleInputChange}
//                       placeholder="Company Registration Number"
//                     />
//                   </div>
//                 </div>
//               </div>
//             </div>

//             <div className=" d-flex justify-content-end">
//               <div className="d-flex gap-3">
//                 <button
//                   type="button"
//                   className="btn bg-danger-subtle text-danger px-4"
//                   onClick={handleCancel}
//                 >
//                   Cancel
//                 </button>
//                 <button
//                   type="submit"
//                   className="btn btn-primary"
//                   disabled={loading}
//                 >
//                   {loading ? "Saving..." : "Save Company"}
//                 </button>
//               </div>
//             </div>
//           </form>
//         </div>
//       </div>

//       <style jsx>{`
//         .bootstrap-modal .ant-modal-content {
//           padding: 0;
//         }
//         .bootstrap-modal .ant-modal-header {
//           display: none;
//         }
//         .bootstrap-modal .ant-modal-body {
//           padding: 24px;
//         }
//         .card {
//           border: 1px solid #dee2e6;
//           border-radius: 0.375rem;
//         }
//         .card-body {
//           padding: 1.5rem;
//         }
//         .card-title {
//           margin-bottom: 0.5rem;
//           font-size: 1.25rem;
//           font-weight: 500;
//         }
//         .card-subtitle {
//           color: #6c757d;
//           font-size: 0.875rem;
//         }
//         .form-label {
//           margin-bottom: 0.5rem;
//           font-weight: 500;
//         }
//         .form-control {
//           display: block;
//           width: 100%;
//           padding: 0.375rem 0.75rem;
//           font-size: 1rem;
//           font-weight: 400;
//           line-height: 1.5;
//           color: #212529;
//           background-color: #fff;
//           background-image: none;
//           border: 1px solid #ced4da;
//           border-radius: 0.375rem;
//           transition: border-color 0.15s ease-in-out,
//             box-shadow 0.15s ease-in-out;
//         }
//         .form-control:focus {
//           color: #212529;
//           background-color: #fff;
//           border-color: #86b7fe;
//           outline: 0;
//           box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
//         }
//         .btn {
//           display: inline-block;
//           font-weight: 400;
//           line-height: 1.5;
//           color: #212529;
//           text-align: center;
//           text-decoration: none;
//           vertical-align: middle;
//           cursor: pointer;
//           border: 1px solid transparent;
//           padding: 0.375rem 0.75rem;
//           font-size: 1rem;
//           border-radius: 0.375rem;
//           transition: color 0.15s ease-in-out,
//             background-color 0.15s ease-in-out, border-color 0.15s ease-in-out,
//             box-shadow 0.15s ease-in-out;
//         }
//         .btn-primary {
//           color: #fff;
//           background-color: #0d6efd;
//           border-color: #0d6efd;
//         }
//         .btn-primary:hover {
//           background-color: #0b5ed7;
//           border-color: #0a58ca;
//         }
//         .bg-danger-subtle {
//           background-color: #f8d7da !important;
//         }
//         .text-danger {
//           color: #dc3545 !important;
//         }
//         .bg-primary-subtle {
//           background-color: #cff4fc !important;
//         }
//         .text-info {
//           color: #0dcaf0 !important;
//         }
//         .alert {
//           position: relative;
//           padding: 1rem 1rem;
//           margin-bottom: 1rem;
//           border: 1px solid transparent;
//           border-radius: 0.375rem;
//         }
//         .alert-dismissible {
//           padding-right: 3rem;
//         }
//         .btn-close {
//           position: absolute;
//           top: 0;
//           right: 0;
//           z-index: 2;
//           padding: 1.25rem 1rem;
//           margin: -1.25rem -1rem -1.25rem auto;
//           background: transparent;
//           border: 0;
//           border-radius: 0.375rem;
//         }
//         .dropdown-menu {
//           position: absolute;
//           top: 100%;
//           left: 0;
//           z-index: 1000;
//           display: none;
//           min-width: 10rem;
//           padding: 0.5rem 0;
//           margin: 0;
//           font-size: 1rem;
//           color: #212529;
//           text-align: left;
//           background-color: #fff;
//           background-clip: padding-box;
//           border: 1px solid rgba(0, 0, 0, 0.15);
//           border-radius: 0.375rem;
//           box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.175);
//         }
//         .dropdown-item {
//           display: block;
//           width: 100%;
//           padding: 0.25rem 1rem;
//           clear: both;
//           font-weight: 400;
//           color: #212529;
//           text-decoration: none;
//           white-space: nowrap;
//           background-color: transparent;
//           border: 0;
//         }
//         .dropdown-item:hover {
//           background-color: #e9ecef;
//         }
//       `}</style>
//     </Modal>
//   );
// };

// export default CompanyFormModal;

import React, { useState, useEffect } from "react";
import "../../App.css";

const CompanyFormModal = ({
  showCompanyForm,
  setShowCompanyForm,
  selectedCompany,
  setSelectedCompany,
  handleCompanySubmit,
  loading,
}) => {
  const [formData, setFormData] = useState({
    company_name: "",
    business_type: "",
    business_description: "",
    business_brief: "",
    address: "",
    caller_name: "",
    phone: "",
    email: "",
    website: "",
    established_year: "",
    gst_number: "",
    pan_number: "",
    registration_number: "",
  });

  useEffect(() => {
    if (selectedCompany) {
      setFormData(selectedCompany);
    } else {
      resetForm();
    }
  }, [selectedCompany]);

  const resetForm = () => {
    setFormData({
      company_name: "",
      business_type: "",
      business_description: "",
      business_brief: "",
      address: "",
      caller_name: "",
      phone: "",
      email: "",
      website: "",
      established_year: "",
      gst_number: "",
      pan_number: "",
      registration_number: "",
    });
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    console.log("Bharat Bhangale");
    e.preventDefault();
    handleCompanySubmit(formData);
  };

  const handleCancel = () => {
    setShowCompanyForm(false);
    setSelectedCompany(null);
    resetForm();
  };

  return (
    <div
      className={`modal fade ${showCompanyForm ? "show d-block" : ""}`}
      tabIndex="-1"
      role="dialog"
      style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
    >
      <div
        className="modal-dialog modal-lg modal-dialog-centered"
        role="document"
      >
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">
              {selectedCompany ? "Edit Company" : "Add New Company"}
            </h5>
            <button
              type="button"
              className="btn-close"
              aria-label="Close"
              onClick={handleCancel}
            ></button>
          </div>

          <div className="modal-body modal-body-scroll">
            <form onSubmit={handleSubmit}>
              <div className="row">
                {/* Company Name */}
                <div className="col-md-6 mb-3">
                  <label htmlFor="company_name" className="form-label">
                    Company Name
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="company_name"
                    name="company_name"
                    value={formData.company_name}
                    onChange={handleInputChange}
                    placeholder="Enter Company Name"
                    required
                  />
                </div>

                {/* Business Type */}
                <div className="col-md-6 mb-3">
                  <label htmlFor="business_type" className="form-label">
                    Business Type
                  </label>
                  <select
                    className="form-control"
                    id="business_type"
                    name="business_type"
                    value={formData.business_type}
                    onChange={handleInputChange}
                  >
                    <option value="">Select Business Type</option>
                    <option value="Private Limited">Private Limited</option>
                    <option value="Public Limited">Public Limited</option>
                    <option value="Partnership">Partnership</option>
                    <option value="Sole Proprietorship">
                      Sole Proprietorship
                    </option>
                    <option value="LLP">LLP</option>
                  </select>
                </div>

                {/* Business Description */}
                <div className="col-12 mb-3">
                  <label htmlFor="business_description" className="form-label">
                    Business Description
                  </label>
                  <textarea
                    className="form-control"
                    id="business_description"
                    name="business_description"
                    value={formData.business_description}
                    onChange={handleInputChange}
                    rows="2"
                    placeholder="Describe your business"
                  />
                </div>

                <div className="mb-3">
                  <label htmlFor="first_message" className="form-label">First Message</label>
                  <input
                    type="text"
                    className="form-control"
                    id="first_message"
                    name="first_message"
                    value={formData.first_message}
                    onChange={handleInputChange}
                  />
                </div>
                {/* System Prompt field always visible */}
                <div className="col-12 mb-3">
                  <label htmlFor="systemPrompt" className="form-label">System Prompt</label>
                  <textarea
                    className="form-control"
                    id="systemPrompt"
                    name="systemPrompt"
                    value={formData.systemPrompt || ''}
                    onChange={handleInputChange}
                  />
                </div>

                {/* Business Brief */}
                <div className="col-12 mb-3">
                  <label htmlFor="business_brief" className="form-label">
                    Business Brief
                  </label>
                  <textarea
                    className="form-control"
                    id="business_brief"
                    name="business_brief"
                    value={formData.business_brief}
                    onChange={handleInputChange}
                    rows="2"
                    placeholder="Brief overview of your business"
                  />
                </div>

                {/* Address */}
                <div className="col-12 mb-3">
                  <label htmlFor="address" className="form-label">
                    Address
                  </label>
                  <textarea
                    className="form-control"
                    id="address"
                    name="address"
                    value={formData.address}
                    onChange={handleInputChange}
                    rows="2"
                    placeholder="Complete Address"
                  />
                </div>

                {/* Contact Person */}
                <div className="col-12 mb-3">
                  <label htmlFor="caller_name" className="form-label">
                    Contact Person
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="caller_name"
                    name="caller_name"
                    value={formData.caller_name}
                    onChange={handleInputChange}
                    placeholder="Primary Contact Person Name"
                  />
                </div>

                {/* Phone */}
                <div className="col-md-6 mb-3">
                  <label htmlFor="phone" className="form-label">
                    Phone Number
                  </label>
                  <input
                    type="tel"
                    className="form-control"
                    id="phone"
                    name="phone"
                    value={formData.phone}
                    onChange={handleInputChange}
                    placeholder="Contact Number"
                    required
                  />
                </div>

                {/* Email */}
                <div className="col-md-6 mb-3">
                  <label htmlFor="email" className="form-label">
                    Email Address
                  </label>
                  <input
                    type="email"
                    className="form-control"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleInputChange}
                    placeholder="Email Address"
                    required
                  />
                </div>

                {/* Website */}
                <div className="col-md-6 mb-3">
                  <label htmlFor="website" className="form-label">
                    Website
                  </label>
                  <input
                    type="url"
                    className="form-control"
                    id="website"
                    name="website"
                    value={formData.website}
                    onChange={handleInputChange}
                    placeholder="Company Website URL"
                  />
                </div>

                {/* Established Year */}
                <div className="col-md-6 mb-3">
                  <label htmlFor="established_year" className="form-label">
                    Established Year
                  </label>
                  <input
                    type="number"
                    className="form-control"
                    id="established_year"
                    name="established_year"
                    value={formData.established_year}
                    onChange={handleInputChange}
                    min="1900"
                    max={new Date().getFullYear()}
                    placeholder="Year Established"
                  />
                </div>

                {/* GST, PAN, Registration */}
                <div className="col-md-4 mb-3">
                  <label htmlFor="gst_number" className="form-label">
                    GST Number
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="gst_number"
                    name="gst_number"
                    value={formData.gst_number}
                    onChange={handleInputChange}
                    placeholder="GST Registration Number"
                  />
                </div>
                <div className="col-md-4 mb-3">
                  <label htmlFor="pan_number" className="form-label">
                    PAN Number
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="pan_number"
                    name="pan_number"
                    value={formData.pan_number}
                    onChange={handleInputChange}
                    placeholder="PAN Number"
                  />
                </div>
                <div className="col-md-4 mb-3">
                  <label htmlFor="registration_number" className="form-label">
                    Registration Number
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="registration_number"
                    name="registration_number"
                    value={formData.registration_number}
                    onChange={handleInputChange}
                    placeholder="Company Registration Number"
                  />
                </div>
              </div>
            </form>
          </div>
          <div className="modal-footer d-flex justify-content-end gap-3 p-3 mt-3">
            <button
              type="button"
              className="btn bg-danger-subtle text-danger px-4"
              onClick={handleCancel}
              style={{ marginRight: "10px" }}
            >
              Cancel
            </button>
            <button
              type="button"
              className="btn btn-primary px-4"
              onClick={handleSubmit}
              disabled={loading}
            >
              {loading ? "Saving..." : "Save Company"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CompanyFormModal;
